import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

const STORAGE_KEY = 'chrona_dev_mode';

/** Routes gated behind dev mode — hidden from customers. */
export const GATED_ROUTES: string[] = [];

interface DevModeContextValue {
  devMode: boolean;
}

const DevModeContext = createContext<DevModeContextValue>({ devMode: false });

export function DevModeProvider({ children }: { children: ReactNode }) {
  const [devMode, setDevMode] = useState(() => sessionStorage.getItem(STORAGE_KEY) === 'true');

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        e.preventDefault();
        setDevMode((prev) => {
          const next = !prev;
          sessionStorage.setItem(STORAGE_KEY, String(next));
          return next;
        });
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return <DevModeContext.Provider value={{ devMode }}>{children}</DevModeContext.Provider>;
}

export function useDevMode() {
  return useContext(DevModeContext);
}
